/* template */
<template><page><base-container :class='["cube-checkbox-modal-page"]'><basic-collapse/><div :class='["divider-wrapper"]'><cube-divider/></div><change-switch-text/><div :class='["divider-wrapper"]'><cube-divider/></div><change-min-height/><div :class='["divider-wrapper"]'><cube-divider/></div><change-position/><div :class='["divider-wrapper"]'><cube-divider/></div><slot-wx-model/></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_66c49013"}'>
.divider-wrapper
  margin: 20px 0
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_66c49013"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_66c49013"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_66c49013"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'basic-collapse':getComponent(require("./basic-collapse.mpx?isComponent&outputPath=components%2Fbasic-collapsecc002c0e%2Findex")),'change-switch-text':getComponent(require("./change-switch-text.mpx?isComponent&outputPath=components%2Fchange-switch-text52ae8796%2Findex")),'change-min-height':getComponent(require("./change-min-height.mpx?isComponent&outputPath=components%2Fchange-min-height67216100%2Findex")),'change-position':getComponent(require("./change-position.mpx?isComponent&outputPath=components%2Fchange-position6d3f4932%2Findex")),'slot-wx-model':getComponent(require("./slot-wx-model.mpx?isComponent&outputPath=components%2Fslot-wx-model2e17386d%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>